/**
 * Implementation of API Fetcher class
 * 
 * @author - Harsh Tomar
 */

import { getUserToken } from "./getUserToken";

export default class Api {
  private static baseUrl = process.env.REACT_APP_API_URL || 'http://localhost:1337'
  
  /**
   * Fetches data from Monitorly API
   * @param endpoint - endpoint to fetch
   * @param options - fetch request options
   * @returns { Promise<string | Record<string, unknown>> } - response from corresponding endpoint
   */
  async fetch(
    endpoint: string,
    options: RequestInit,
  ): Promise<string | Record<string, unknown>> {
    try {
      const token = getUserToken();
      const resObj = await fetch(`${Api.baseUrl}${endpoint}`, {
        method: options.method || 'GET',
        headers: {
          'Content-Type': 'application/json',
          
          ...token && {
            'Authorization': `Bearer ${token}`
          },
          ...options.headers,
        },
        ...options,
      });

      const res = await resObj.json();

      if (!resObj.ok) {
        if(resObj.status === 500)
          return Promise.reject("Internal error")

        return Promise.reject(res.message)
      }

      return res;
    } catch (err: any) {
      return Promise.reject(err.toString());
    }
  }

  async get(endpoint: string) {
    return this.fetch(endpoint, { method: 'GET' });
  }

  async post(endpoint: string, data?: Record<string, unknown>) {
    return this.fetch(endpoint, { method: 'POST', body: JSON.stringify(data || '{}')})
  }

  async put(endpoint: string, data?: Record<string, unknown>) {
    return this.fetch(endpoint, { method: 'PUT', body: JSON.stringify(data || '{}') })
  }

  async patch(endpoint: string, data?: Record<string, unknown>) {
    return this.fetch(endpoint, { method: 'PATCH', body: JSON.stringify(data || '{}') })
  }
}